import { cloudApi } from './http.js'

export function inspectMemberInvitation(token) {
  return cloudApi.get(`/api/web/member-invitations/${encodeURIComponent(token)}`)
}

export function acceptMemberInvitation(token) {
  return cloudApi.post(`/api/web/member-invitations/${encodeURIComponent(token)}:accept`, {})
}
